import { gql } from "@apollo/client";

export const DecliningUsageGQL = gql`
  {
    significantDropLockers {
      lockerId
      lockerName
      dropPercentage
      dropPackage
      baselinePeriod
      recentPeriod
      dataQuality
      declineType
      baselineAvg
      recentAvg
      accelerationRate
      isAccelerating
      healthScore
      volatilityIndex
      yoyPeriod
      yoyAvg
      yoyChangePercentage
    }
  }
`;

export const DecliningUsageWithExtrapolationGQL = gql`
  {
    significantDropLockersWithExtrapolation {
      lockerId
      lockerName
      dropPercentage
      dropPackage
      baselinePeriod
      recentPeriod
      dataQuality
      declineType
      baselineAvg
      recentAvg
      accelerationRate
      isAccelerating
      healthScore
      volatilityIndex
      yoyPeriod
      yoyAvg
      yoyChangePercentage
    }
  }
`;

export const YoYAnalysisGQL = gql`
  {
    yoyAnalysisLockers {
      lockerId
      lockerName
      dropPercentage
      dropPackage
      baselinePeriod
      recentPeriod
      dataQuality
      declineType
      baselineAvg
      recentAvg
      accelerationRate
      isAccelerating
      healthScore
      volatilityIndex
      yoyPeriod
      yoyAvg
      yoyChangePercentage
      yoyCategory
      declineStartMonth
    }
  }
`;

export const QUERY_HighRemovalCourier = gql`
  query ($operatorId: ID!) {
    multipleRemoved(operatorId: $operatorId) {
      recipients
      recipientsAll
      elapsedHrsAvg
      statusDate
      courier
      occurrenceCount
      elapsedHrsAvgAll
    }
  }
`;

export const ClearingReportGQL = gql`
  {
    lockersWithOverduePackages {
      lockerId
      lockerName
      totalPackages
      oldestPackageDate
    }
  }
`;
